import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Box, IconButton } from "@mui/material";
import DropDown from "../../../components/common/DropDown/DropDown";
import SocialConnection from "../../../components/single/SocialConnection/SocialConnection";
import { AiOutlineMail } from "react-icons/ai";
import PropTypes from "prop-types";
import { apiFetch } from "../../../utils/api"; // Make sure this is imported
import styles from "./Footer.module.css";
import * as Sentry from "@sentry/react";

const Footer = ({ className = "" }) => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const handleCurrencySelect = (currency) => {
    console.log("Selected Currency:", currency);
  };

  const handleEmailSubmit = async () => {
    if (!email) {
      setError("Please enter your email.");
      return;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    
    try {
      const res = await apiFetch("/subscribe", {
        method: "POST",
        body: JSON.stringify({ email }),
      });
      if (res && res.status === "ok") {
        setSubscribed(true);
        setEmail("");
        setError("");
      } else {
        throw new Error("Subscription failed");
      }
    } catch (err) {
      Sentry.captureException(err);
      setError("Subscription failed. Please try again.");
    }
  };

  return (
    <footer className={[styles.footer, className].join(" ")}>
      <Box className={styles.main}>
        <Box className={styles.left}>
          <Box className={styles.subscribe}>
            <Typography className={styles.subscribeToUpdates}>Subscribe to updates</Typography>

            {subscribed ? (
              <Typography className={styles.successMessage}>Thank you for your interest!</Typography>
            ) : (
              <>
                <Box className={styles.emailInputWrapper}>
                  <input
                    type="text"
                    placeholder="Enter your e-mail"
                    value={email}
                    onChange={handleEmailChange}
                    className={styles.emailInput}
                  />
                  <IconButton onClick={handleEmailSubmit} className={styles.mailIcon}>
                    <AiOutlineMail />
                  </IconButton>
                </Box>
                {error && <Typography className={styles.errorText}>{error}</Typography>}
              </>
            )}
          </Box>

          {/* <Box className={styles.follow}>
            <Typography className={styles.followUs}>Follow us</Typography>
            <SocialConnection />
          </Box> */}
        </Box>

        <Box className={styles.footerLinks}>
          <Box className={styles.links01}>
            <Typography className={styles.sectionTitle}>Links</Typography>
            {/* <Typography onClick={() => navigate("/help")} className={styles.link}>Become a creator</Typography> */}
            <Typography onClick={() => navigate("/help")} className={styles.link}>Help Center</Typography>
            {/* <Typography onClick={() => navigate("/help")} className={styles.link}>Become a Partner</Typography> */}
            {/* <Typography onClick={() => navigate("/about-us")} className={styles.link}>About Us</Typography> */}
            
          </Box>
        </Box>

        <Box className={styles.currencySection}>
          <Typography className={styles.region}>About us</Typography>
          <Box className={styles.description}>
            MementoMaster LLC<br></br>
            Delaware, USA
          </Box>
          <Box className={styles.description}>
            A platform that empowers athletes, artists, and creators to sell
            authentic moments from their lives directly to their fans.
          </Box>
          {/* <DropDown onSelect={handleCurrencySelect} /> */}
        </Box>
      </Box>

      {/* <Box className={styles.links}>
        <Typography className={styles.privacyPolicy}>Privacy Policy</Typography>
        <Typography className={styles.privacyPolicy}>License</Typography>
        <Typography className={styles.privacyPolicy}>API</Typography>
      </Box> */}
      <Box className={styles.allRightsReserved}>© 2025 All rights reserved</Box>
    </footer>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;